import { motion } from "framer-motion";

export default function SolarPanel() {
  return (
    <section
      className="relative py-20 px-6 text-white"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.85) 0%, rgba(249,122,8,0.3) 100%), url('/assets/s1.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      {/* CONTENT WRAPPER */}
      <div className="max-w-6xl mx-auto">
        {/* 🔥 Heading */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-orange-400 mb-4">
            Solar Solutions ⚡
          </h2>

          <p className="text-white/80 max-w-2xl mx-auto leading-relaxed">
            Power your future with SolidEra Energy. We provide efficient,
            cost-saving, and sustainable solar solutions tailored for homes and
            businesses.
          </p>
        </motion.div>

        {/* 🔥 SERVICES */}
        <h3 className="text-2xl font-semibold text-white mb-8 text-center">
          Services Offered
        </h3>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {[
            {
              title: "Complete Solar Installation",
              img: "/assets/portfolio/industrial.jpg",
            },
            {
              title: "Solar Project Vendorship",
              img: "/assets/portfolio/vendor.jpg",
            },
            {
              title: "Net Metering Services",
              img: "/assets/portfolio/metering.jpg",
            },
            {
              title: "Preventive Maintenance",
              img: "/assets/portfolio/preventive.jpg",
            },
            {
              title: "Corrective Maintenance",
              img: "/assets/portfolio/corrective.jpg",
            },
            {
              title: "Panel Washing Service",
              img: "/assets/portfolio/washing.jpg",
            },
            {
              title: "Earthing Solutions",
              img: "/assets/portfolio/earthing.jpg",
            },
          ].map((service, i) => (
            <motion.div
              key={i}
              whileHover={{ scale: 1.05 }}
              className="bg-black/40 backdrop-blur-md rounded-xl overflow-hidden border border-orange-500/20 hover:border-orange-400 hover:shadow-[0_0_20px_rgba(249,115,22,0.4)] transition"
            >
              <img
                src={service.img}
                alt={service.title}
                className="w-full h-48 object-cover hover:scale-110 transition duration-500"
              />
              <div className="p-4 text-center">
                <p className="text-white font-medium">{service.title}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* 🔥 PRODUCTS */}
        <h3 className="text-2xl font-semibold text-white mb-8 text-center">
          Products Available
        </h3>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {[
            {
              title: "Solar Panels & Inverters",
              img: "/assets/products/solarandinverter.jpg",
            },
            {
              title: "Lithium-ion & Tubular Batteries",
              img: "/assets/products/Lithium.jpeg",
            },
            {
              title: "Electrical Accessories",
              img: "/assets/products/electrical.jpg",
            },
          ].map((product, i) => (
            <motion.div
              key={i}
              whileHover={{ scale: 1.05 }}
              className="relative rounded-2xl overflow-hidden group cursor-pointer"
            >
              <img
                src={product.img}
                alt={product.title}
                className="w-full h-60 object-cover group-hover:scale-110 transition duration-500"
              />

              <div className="absolute inset-0 bg-black/60 group-hover:bg-black/40 transition"></div>

              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <h3 className="text-white text-xl font-bold group-hover:text-yellow-400 transition">
                  {product.title}
                </h3>
              </div>

              <div className="absolute inset-0 border border-yellow-500/30 rounded-2xl group-hover:border-yellow-400 group-hover:shadow-[0_0_25px_rgba(250,204,21,0.5)] transition-all"></div>
            </motion.div>
          ))}
        </div>

        {/* 🔥 SOCIAL */}
        <div className="text-center mb-16">
          <p className="text-white/60 mb-4">
            Stay connected with us on social media
          </p>

          <div className="flex justify-center gap-4">
            <a
              href="https://www.facebook.com/profile.php?id=61574004411820"
              target="_blank"
              rel="noreferrer"
              className="px-6 py-2 border border-orange-400 text-orange-400 rounded-lg hover:bg-orange-400 hover:text-black transition"
            >
              Facebook
            </a>

            <a
              href="https://www.instagram.com/solid_era_energy/"
              target="_blank"
              rel="noreferrer"
              className="px-6 py-2 border border-orange-400 text-orange-400 rounded-lg hover:bg-orange-400 hover:text-black transition"
            >
              Instagram
            </a>
          </div>
        </div>

        {/* 🔥 CTA */}
        <div className="text-center">
          <h3 className="text-2xl font-bold text-orange-400 mb-4">
            Save More, Live Smarter 🌱
          </h3>

          <p className="text-white/70 mb-6">
            Embrace a greener future with SolidEra Energy today.
          </p>

          <button
            onClick={() => window.open("https://wa.me/923337111075", "_blank")}
            className="px-8 py-3 bg-gradient-to-r from-orange-400 to-yellow-500 text-black font-bold rounded-lg hover:scale-105 transition"
          >
            Get Started
          </button>
        </div>
      </div>
    </section>
  );
}
